import type {
  EmployeeTreatmentStart,
  RecordTreatmentStart,
} from "@care-by-ella/contracts";
import { API_BASE, apiFetch, withCredentials } from "./api";
import { commonHeaders, jsonOr401 } from "./clinician-api";

// TES-1073 (Ö-298) — the documented earlier treatment start. The doctor reads
// and writes; an admin in her support view reads.

const url = (patientId: string) =>
  `${API_BASE}/employee-api/v1/patients/${patientId}/earlier-treatment-start`;

export async function getEarlierTreatmentStart(
  patientId: string,
): Promise<EmployeeTreatmentStart> {
  const res = await apiFetch(url(patientId), {
    headers: commonHeaders(),
    ...withCredentials,
  });
  return jsonOr401(res);
}

export async function recordEarlierTreatmentStart(
  patientId: string,
  body: RecordTreatmentStart,
): Promise<EmployeeTreatmentStart> {
  const res = await apiFetch(url(patientId), {
    method: "PUT",
    headers: commonHeaders(),
    body: JSON.stringify(body),
    ...withCredentials,
  });
  return jsonOr401(res);
}
